// import axios from 'axios';

// const API_BASE_URL = 'http://localhost:5000/api';

// // Create axios instance with base configuration
// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // API functions
// export const postsAPI = {
//   // Create new post
//   createPost: async (postData) => {
//     try {
//       const response = await api.post('/posts/create', postData);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data || error.message;
//     }
//   },

//   // Get all posts
//   getAllPosts: async () => {
//     try {
//       const response = await api.get('/posts/all');
//       return response.data;
//     } catch (error) {
//       throw error.response?.data || error.message;
//     }
//   }
// };

// // export default api;
// // export { postsAPI };
// export default postsAPI; 


import axios from 'axios';

const API_BASE_URL = 'https://quickpost.webzgrowth.in/api';
// const API_BASE_URL = 'http://localhost:5000/api';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
});

// API functions
export const postsAPI = {
  // Create new post with file upload
  // createPost: async (formData) => {
  //   try {
  //     const response = await api.post('/posts/create', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data', // Important for file uploads
  //       },
  //     });
  //     return response.data;
  //   } catch (error) {
  //     throw error.response?.data || error.message;
  //   }
  // },

  createPost: async (formData, onUploadProgress) => {
    try {
      const response = await api.post('/posts/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (onUploadProgress) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onUploadProgress(percentCompleted);
          }
        },
        timeout: 600000,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // // Get all posts
  // getAllPosts: async () => {
  //   try {
  //     const response = await api.get('/posts/all');
  //     return response.data;
  //   } catch (error) {
  //     throw error.response?.data || error.message;
  //   }
  // }

  // Get single post by ID
  getPostById: async (postId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching post:', error);
      throw error;
    }
  },

  // Update post
  updatePost: async (postId, formData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/posts/${postId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  },

  // Delete post
  deletePost: async (postId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting post:', error);
      throw error;
    }
  },

  // Get all posts for user (with optional client filter)
  getAllPosts: async (userId, clientId = null) => {
    try {
      let url = `/posts/all?user_id=${userId}`;
      if (clientId && clientId !== 'all') {
        url += `&client_id=${clientId}`;
      }
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Client API functions
export const clientsAPI = {
  // Get all clients for organization
  getMyClients: async (token) => {
    try {
      const response = await api.get('/clients/my-clients', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add new client
  addClient: async (clientData, token) => {
    try {
      const response = await api.post('/clients/add-client', clientData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update client
  updateClient: async (clientId, clientData, token) => {
    try {
      const response = await api.put(`/clients/update-client/${clientId}`, clientData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete client
  deleteClient: async (clientId, token) => {
    try {
      const response = await api.delete(`/clients/delete-client/${clientId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Credentials API functions
export const credentialsAPI = {
  // Add or update credential
  addCredential: async (credentialData, token) => {
    try {
      const response = await api.post('/credentials/add-credential', credentialData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user's credentials
  getMyCredentials: async (token, clientId = null, platform = null) => {
    try {
      let url = '/credentials/my-credentials';
      const params = [];
      
      if (clientId) params.push(`client_id=${clientId}`);
      if (platform) params.push(`platform=${platform}`);
      
      if (params.length > 0) {
        url += '?' + params.join('&');
      }

      const response = await api.get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Verify credential connection
  verifyCredential: async (credentialData, token) => {
    try {
      const response = await api.post('/credentials/verify-credential', credentialData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete credential
  deleteCredential: async (credentialId, token) => {
    try {
      const response = await api.delete(`/credentials/delete-credential/${credentialId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default api;